// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rust-contract-detector[data-v-72215105]{min-height:var(--base-main-router-body-avaliable-height)}.rust-contract-detector .action-bar-checkbox[data-v-72215105]{margin-right:var(--base-size-16);line-height:var(--base-size-32)}", ""]);
// Exports
module.exports = exports;
